import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const documentationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentations: builder.query({
      query: () => `/sdk/documentations`,
      providesTags: (result, error, arg) => [{ type: 'Documentation', id: 'LIST' }],
    }),
    syncDocumentations: builder.mutation({
      query: () => ({
        url: 'sdk/documentations/sync',
        method: 'POST'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.sync")}),
      invalidatesTags: (result, error, arg) => [{ type: 'Documentation', id: 'LIST' }]
    })
  }),
  overrideExisting: false
})

export const {
  useGetDocumentationsQuery,
  useSyncDocumentationsMutation
} = documentationApiSlice
